// src/features/channelManager/components/ChannexIframeModal.jsx
import React from "react";
import { Modal } from "antd";

export default function ChannexIframeModal({ open, onClose, url, title = "Channel Mapping" }) {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width="92vw"
      style={{ top: 18 }}
      bodyStyle={{ padding: 0, height: "86vh" }}
      title={title}
      zIndex={9000}
      destroyOnClose
    >
      {url ? (
        <iframe
          title="Channex IFrame"
          src={url}
          style={{ width: "100%", height: "86vh", border: 0 }}
          allow="clipboard-read; clipboard-write"
        />
      ) : (
        <div style={{ padding: 24 }}>No iframe url</div>
      )}
    </Modal>
  );
}
